import {USER_PROFILE} from '../../../endpoints'
import {apiPublic} from '../../../api'
import types from '../types/confirmEmail'
import {endpoint as endpointText} from '../../../common/text'

export default class confirmEmail {

  static save(code, email) {
    return function(dispatch, getState) {

      if (code === '' || email === '') {
        dispatch(confirmEmail.fetchFail(''))
        return
      }

      dispatch({type: types.SAVE})

      const data = new FormData()
      data.append('code', code)
      data.append('email', email)

      apiPublic.put(USER_PROFILE + '/verifyEmail', data)
        .then(response => {
          dispatch(confirmEmail.saveSuccess())
          confirmEmail.goToNextStep()
        }, error => {
          let message = ''
          if (error.response) {
            message = error.response.data.description //TODO maybe parse this? So it does't crash if description doesn't exist
          } else if (error.request) {
            message = endpointText.internetMayBeTheProblem
          } else {
            message = endpointText.somethingWentWrong
          }
          dispatch(confirmEmail.saveFail(message))
          confirmEmail.goToNextStep()
        })
    }
  }

  static goToNextStep() {
    const urlParams = new URLSearchParams(window.location.search)
    if (urlParams.has('tyc_link')) {
      window.location = urlParams.get('tyc_link')
    } else {
      window.location.pathname = '/micatalogo'            
    }
  }

  static saveSuccess() {
    return {
      type: types.SAVE_SUCCESS,
    }
  }

  static saveFail(error) {
    return {
      type: types.SAVE_FAIL,
      payload: {
        error,
      },
    }
  }

}



// WEBPACK FOOTER //
// ./src/sections/confirmEmail/actions/confirmEmail.js